import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'components.PasswordVerifyModal.title',
    defaultMessage: 'Password',
    description: '标题',
  },
})
